import { getRgObjectsOfType as o, RgChildren as i, RG_TYPE as t } from "@project-rouge/rg-core";
import { isBaseBuildObject as l } from "../../queries/index2.js";
import { isDoubleDoor as n } from "../../queries/index3.js";
const d = (e) => {
  const r = o(e, i.Building);
  return o(r.filter(l), t.Door).filter(n).length;
};
export {
  d as getBaseBuildDoubleDoorsCount
};
//# sourceMappingURL=index6.js.map
